import type { FirebaseIntegrationPlugin } from './firebaseIntegrationPlugin';
import { type BetterAuthClientPlugin } from 'better-auth';

export const firebaseIntegrationClientPlugin = () => {
	return {
		id: 'firebaseIntegrationPlugin',
		$InferServerPlugin: {} as ReturnType<FirebaseIntegrationPlugin>
	} satisfies BetterAuthClientPlugin;
};
